<div class="main-box add-candidates-from-job-boards-container" *ngIf="!isLoading">
    <div class="row">
        <div class="col-xs-12 text-danger add-candidates-job-boards-pull-limit-warning-container" *ngIf="isTrialPlanActive && job.jobBoardDetails.length>0">
           <span *ngIf="jobBoardsResumePullLeft>0" class="add-candidates-job-boards-pull-limit-warning">
               You are on a Trial Plan. You can pull only <span>{{jobBoardsPullResumePulled + jobBoardsResumePullLeft}} </span> resumes from Job Boards. Currently you have pulled <span>{{jobBoardsPullResumePulled}}</span> resumes. You have <span>{{jobBoardsResumePullLeft}}</span> pulls left.
           </span>
           <span *ngIf="jobBoardsResumePullLeft == 0" class="add-candidates-job-boards-pull-limit-warning">
              You have no free Job Board Resume Pulls Left. Please talk to you administrator to resolve the issue.
           </span>
        </div>
        <div class="col-xs-10">
            <div class="col-xs-3">
                <span [tooltip]="'Currently Active Candidates'">
                    Active Candidates : {{requisitionDetails.activeCandidateCount}}
                </span>
            </div>
            <div class="col-xs-3">
                <span style="margin-left:1px" [tooltip]="'Currently Passive Candidates'">
                    Passive Candidates : {{requisitionDetails.passiveCandidateCount}}
                </span>
            </div>
            <div class="col-xs-3">
                <span style="margin-left:20px" [tooltip]="'Currently Inert Candidates'">
                    Inert Candidates : {{requisitionDetails.inertCandidateCount}}
                </span>
            </div>
            <div class="col-xs-3">
                <span [tooltip]="'Unfilled Openings of Total Openings'">
                    Open Positions : {{requisitionDetails.noOfOpenings -
                    requisitionDetails.noOfJustFilledOpenings}} /
                    {{requisitionDetails.noOfOpenings}}
                </span>
            </div>
        </div>
        <div class="col-xs-2 text-right">
            <div *ngIf="isGetCandidateFetchCalled">
                <span [tooltip]="'Candidates Fetch In-Progress'">
                    <span class="fa fa-2x fa-spinner fa-spin"></span>
                </span>
            </div>
        </div>
    </div>
    <div class="row job-boards-parameters-container">
        <div *ngIf="job.jobBoardDetails.length !== 0">
             <app-job-boards-supported-parameters [job]="job" context="global" [isEditable]="isParametersEditable"
                (jobBoardsSelectionChange)="onJobBoardSelectionChange()" [radiusOptions]="radiusOptions"
                [recencyOptions]="recencyOptions" [resumePullOptions]="resumePullCounts"
                [activeFilterTab]="activeJobBoardsFilterTabNumber">
            </app-job-boards-supported-parameters>
        </div>
        <div *ngIf="job.jobBoardDetails.length === 0" class="text-center">
            No Job Board(s) available. Please setup the job board(s).
        </div>
    </div>
</div>

<div class="row" *ngIf="!isLoading">
    <div class="col-xs-12 text-right">
        <div>
            <button class="btn btn-danger mr-2" (click)="cancel()">
                <span>Cancel</span>
            </button>
            <button type="submit" class="btn btn-success" (click)="checkStatusAndGetResumesFromJobBoards()"
            [disabled]="job.resumesToPullPerJobBoardCount == null || job.resumesToPullPerJobBoardCount == undefined || !isJobBoardSelected || isGetCandidateFetchCalled">
                <span>Get Candidates</span>
            </button>
        </div>
    </div>
</div>
<div class="row skeleton-container" *ngIf="isLoading">
    <div class="col-xs-12">
        <div class="col-xs-3"><div class="skeleton-paragraph skeleton-loading" style="width:80%"></div></div>
        <div class="col-xs-3"><div class="skeleton-paragraph skeleton-loading" style="width:80%"></div></div>
        <div class="col-xs-3"><div class="skeleton-paragraph skeleton-loading" style="width:80%"></div></div>
        <div class="col-xs-3"><div class="skeleton-paragraph skeleton-loading" style="width:80%"></div></div>
    </div>
    <div class="col-xs-12" style="margin-top:20px">
        <div class="skeleton-heading skeleton-loading" style="width:40%; margin-bottom:15px"></div>
        <div class="skeleton-content skeleton-loading" style="margin-bottom:10px"></div>
        <div class="skeleton-content skeleton-loading" style="margin-bottom:10px"></div>
        <div class="skeleton-content skeleton-loading"></div>
    </div>
</div>
